<template>
    <div>
        <main v-if="!loading">
            <backoffice-header />
            <router-view/>
            <backoffice-footer />
        </main>

        <modal-notification ref="notification"/>
    </div>
</template>

<script>
    //import Vue from 'vue'
    import { app_config } from '@/config'
    import BackofficeHeader from '@/components/blocks/backoffice-header'
    import BackofficeFooter from '@/components/blocks/backoffice-footer'
    import ModalNotification from '@/components/modal-notification'
    export default {
        name: 'app',
        components: {
            'backoffice-header': BackofficeHeader,
            'backoffice-footer': BackofficeFooter,
            'modal-notification': ModalNotification,
        },
        data() {
            return {
            }
        },
        computed: {
            loading: {
                get()
                {
                    return this.$store.state.loading
                },
                set(value)
                {
                    this.$store.commit('set_loading', value)
                }
            }
        },
        beforeMount() {
            this.app_config = app_config
            let _this = this
            let wait_router_interval = setInterval(function() {
                // aspetto che il router carichi la rotta attuale, altrimenti app_config non riesce a leggere l'eventuale token in get
                if (_this.$route.name == null) return
                clearInterval(wait_router_interval)
                _this.app_config()
                    .then(() => {
                        _this.loading = false
                    })
            }, 100);
        },
        mounted() {
            let _this = this
                window.eventBus.$on('gotNotification', function(data) { 
                _this.$refs.notification.handle_notification(data)
            })            
        },
        created () {
        },
        destroyed () {
        },
        methods: {
        }
    }
</script>

<style lang="scss">
    @import 'scss/_app.scss';
    .backoffice
    {
        width:calc(100% - #{$backoffice-sidebar-width});
        margin-left: $backoffice-sidebar-width;
        padding:$grid-gutter-width/2 0;
        padding-top:$backoffice-head-height;
        margin-top:$grid-gutter-width;
        &--sticky
        {
            position:fixed;
            top:0;
            left:0;
            width:100%;
            height:$backoffice-head-height;
            z-index:10;
            background:$white;
            display:flex;
            align-items: center;
            box-shadow: 0 3px 10px $gray-400;
            padding-bottom: $grid-gutter-width/6;
        }
    }
    
</style>